import React from 'react';
import { Link } from 'react-router-dom';
import { LenticLogo } from '../LenticLogo';
import { EYEBROW } from './Band';
import { useHashHref } from './Nav';
import { footerColumns } from '../../data/site';
export function Footer() {
  const hrefFor = useHashHref();
  return <footer className="w-full border-t border-mist bg-bone" data-id="element-157" data-mp="31f0epg2g41p4">
      <div className="mx-auto w-full max-w-6xl px-6 py-16 lg:px-10 lg:py-20" data-id="element-158" data-mp="31fjwmws3iq35">
        <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.2fr_repeat(3,0.8fr)]" data-id="element-159" data-mp="3p5nqicfhfbgy">
          <div data-id="element-160" data-mp="3u3yzkkxydhy4">
            <LenticLogo size={30} data-id="element-161" data-mp="3u2e5ewfjw10s" />
            <p className="mt-5 max-w-[32ch] text-[15px] leading-relaxed text-graphite" data-id="element-162" data-mp="3u5ig8cnitv0f">
              Independent assessment of judgement in AI-assisted work, and the
              record that proves how the decision was made.
            </p>
          </div>

          {footerColumns.map(column => <nav key={column.title} aria-label={column.title} data-id="element-163" data-mp="bvzrgxha7r2e">
              <h3 className={`${EYEBROW} text-graphite`} data-id="element-164" data-mp="gpuiklz7v8bi">{column.title}</h3>
              <ul className="mt-5 space-y-3" data-id="element-165" data-mp="3jf2wu5znflwr">
                {column.links.map(link => <li key={link.label} data-id="element-166" data-mp="3jd88sit2zdog">
                    {link.href.startsWith('/') ? <Link to={link.href} className="text-[15px] text-ink transition-colors hover:text-teal" data-id="element-167" data-mp="3ei2sbzig6r7r">
                        {link.label}
                      </Link> : <a href={hrefFor(link.href)} className="text-[15px] text-ink transition-colors hover:text-teal" data-id="element-168" data-mp="3ngo4ncxbta03">
                        {link.label}
                      </a>}
                  </li>)}
              </ul>
            </nav>)}

          <div data-id="element-169" data-mp="113etanfb6bd">
            <h3 className={`${EYEBROW} text-graphite`} data-id="element-170" data-mp="13pnxepyptvp">Contact</h3>
            <ul className="mt-5 space-y-3 text-[15px]" data-id="element-171" data-mp="f0350mql3t9n">
              <li data-id="element-172" data-mp="azsx34j8ess5">
                <a href="mailto:hello@lentic.ai" className="text-ink transition-colors hover:text-teal" data-id="element-173" data-mp="azj89k9xaro1">
                  hello@lentic.ai
                </a>
              </li>
              <li className="text-graphite" data-id="element-174" data-mp="2cr5tt6b1pud4">London, United Kingdom</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-mist pt-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-175" data-mp="fr1ijmkffqtl">
          <p className="text-sm text-graphite" data-id="element-176" data-mp="kqe4m53h4tv4">
            © {new Date().getFullYear()} Lentic. Assessment, not detection.
          </p>
          <p id="legal" className="scroll-mt-24 text-sm text-graphite" data-id="element-177" data-mp="pr26jlt8qv44">
            Privacy policy · Candidate privacy notice · DPA · Security
          </p>
        </div>
      </div>
    </footer>;
}